<template>
  <div class="bridge-info-block noselect">
    <!-- Modal Info Selezione Deck -->
    <ModalCalendar
      v-if="showCalendar && getDateRange[0] && getDateRange[1]"
      :datarange="[getDateRange[0], getDateRange[1]]"
      @close="showCalendar = false"
      @update="updateDate"
      @range-selected="rangeSelected"
      :maxDate="isLambro ? new Date('2021-04-23'): new Date()"
      class="ciao"
      id="cal-events"
    />
    <div id="event-info">
      <h2>{{ $t("title.eventDetails") }}</h2>
      <div class="vert-divider"></div>

      <div @click="calendarHandler" class="info-group">
        <p class="info-btn">{{ $t("message.dateRange") }}:</p>
        <h2 class="info-btn">
          {{ this.formattedDate[0] + " - " + this.formattedDate[1] }}
        </h2>
        <i class="info-btn" v-bind:class="[showCalendar ? 'up' : 'down']"></i>
      </div>

      <!-- Relative Switch -->
      <div id="relative-switch">
        <p class="info-btn" :class="{ textdisabled: !compensable }">{{ $t("message.dataCompensation") }}:</p>
        <p :class="{ textdisabled: !compensable }">
          {{ this.getRelativeMode ? $t("message.activeF") : $t("message.inactiveF") }}
        </p>
        <label class="switch">
          <input type="checkbox" :disabled="!compensable" v-model="relativeMode" />
          <span class="slider round" :class="{ colordisabled: !compensable }"></span>
        </label>
      </div>
    </div>
    <div class="horiz-divider"></div>
    <!-- Ponte e Sensors in overlay -->
    <div class="bridge-draw-block">
      <BridgeDrawMin
        :spans="structureDetails.spans"
        :sensors="structureDetails.sensors"
        :selectedFromParent="this.getSelectedSensor"
        :structureDetails="structureDetails"
        @sensor-selected="filterBySensor"
      />
    </div>
    <div class="overview">
      <h2>{{ $t("title.dataSummary") }}:</h2>
      <div class="data-info">
        <p class="data-label">{{ $t("message.counterEvents") }}</p>
        <p class="data-value">{{ this.getEventsCounter || " - " }}</p>
      </div>
      <div class="data-info">
        <p class="data-label">{{ $t("message.dailyAverageEvents") }}</p>
        <p class="data-value">{{ this.eventsMeanPerDay || " - " }}</p>
      </div>
      <div class="data-info" v-if="getSensorType != 'analog-node'">
        <p class="data-label">{{ $t("message.minTemp") }}</p>
        <p class="data-value">{{ this.minTemperature || " - " }}</p>
      </div>
      <div class="data-info" v-if="getSensorType != 'analog-node'">
        <p class="data-label">{{ $t("message.maxTemp") }}</p>
        <p class="data-value">{{ this.maxTemperature || " - " }}</p>
      </div>
      <div class="buttons-wrapper">
        <div>
          <!-- <input type="checkbox" id="sel-sensor-only" name="sel-sensor-only" v-model="downloadSelSensorOnly" />
          <label for="sel-sensor-only">{{ $t("message.downloadSelSensorOnly") }}</label> -->
          <label for="sel-sensor-only">{{ $t("message.dataOf") }}:</label>
          <select name="sel-sensor-only" id="sel-sensor-only" v-model="downloadSelSensorOnly">
            <option :value="true">{{ $t("message.selSensor") }}</option>
            <option :value="false">{{ $t("message.allSensors") }}</option>
          </select>
        </div>
        <div>
          <label for="desc-date">{{ $t("message.dateSorting") }}:</label>
          <select name="desc-date" id="sdesc-date" v-model="downloadDescDate">
            <option :value="true">{{ $t("message.descending") }}</option>
            <option :value="false">{{ $t("message.ascending") }}</option>
          </select>
        </div>
        <button class="download-button" @click="downloadEvents" :disabled="!this.getIsThereData || !this.getLoadingStatus">
          <img class="down-small" src="../../../../public/assets/download-small-white.svg" width="24px" />
          {{ loadingMex || "Download" }}<br />
          <span>Riepilogo.csv</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import BridgeDrawMin from "../../ui/BridgeDrawMin.vue";
import ModalCalendar from "../../ui/ModalCalendar.vue";
import download from "../../../helpers/download.js";
import math from "../../../helpers/math.js";
import api from "../../../services/api";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "bridgeinfo-module",
  components: {
    BridgeDrawMin,
    ModalCalendar,
  },
  data() {
    return {
      selected: [],
      firstExec: true,
      actualDateRange: [],
      showCalendar: false,
      downloadSelSensorOnly: true,
      downloadDescDate: true,
    };
  },
  props: {
    structureDetails: Object, // Dettagli sulla struttura
  },
  computed: {
    ...mapGetters({
      getDateRange: "eventdetails/getDateRange",
      getSensors: "structure/getSensors",
      getDispList: "eventdetails/getDisplacementList",
      getSelectedSensor: "eventdetails/getSelectedSensor",
      getRelativeMode: "eventdetails/getRelativeMode",
      getEventsCounter: "eventdetails/getEventsCounter",
      getTemperaturesList: "eventdetails/getTemperaturesList",
      getCracks: "eventdetails/getCracks",
      getAccelerations: "eventdetails/getAccelerations",
      getAnalogReadings: "eventdetails/getAnalogReadings",
      getTilts: "eventdetails/getTilts",
      getSensorType: "eventdetails/getSensorType",
      getIsThereData: "eventdetails/getIsThereData",
      getLoadingStatus: "eventdetails/getLoadingStatus",
      getBaseValue: "eventdetails/getBaseValue",
      getUserInterface: "user/getInterface",
    }),
    isLambro() {
      return this.getSensors ? this.getSensors.some((sn) => sn.eui === "C0EE400001015144") : false;
    },
    mesUnit() {
      return this.getUserInterface ? this.getUserInterface.dimensions : null;
    },
    relativeMode: {
      // Getter & Setter per relativeMode
      get() {
        return this.getRelativeMode;
      },
      set(value) {
        this.setRelativeMode(value);
      },
    },
    loadingMex: function () {
      // Messaggio da visualizzare nel bottone di Download Eventi
      let mex;
      if (!this.getLoadingStatus) mex = "Loading...";
      else if (!this.getIsThereData && this.getLoadingStatus) mex = this.$t("message.noData");
      return mex;
    },
    formattedDate: function () {
      // Data formattata
      let firstDate;
      let lastDate;
      if (this.getDateRange[0] && this.getDateRange[1]) {
        firstDate = this.formatDate(this.getDateRange[0]);
        lastDate = this.formatDate(this.getDateRange[1]);
      }
      return [firstDate, lastDate];
    },
    deckList: function () {
      // Lista di dispositivi deck
      let deckList = [];
      if (this.structureDetails.sensors.length > 0) {
        deckList = this.structureDetails.sensors.filter((sensor) => sensor.type === "deck");
      }
      return deckList;
    },
    compensable: function () {
      let compensable = false;
      if (this.getSelectedSensor && (this.getSelectedSensor.type === "tiltmeter" || this.getSelectedSensor.type === "crackmeter")) compensable = true;
      return compensable;
    },
    eventsMeanPerDay: function () {
      let mean = null;
      if (this.getEventsCounter && this.getDateRange[0] && this.getDateRange[1]) {
        let counter = this.getEventsCounter;
        // To calculate the time difference of two dates
        var Difference_In_Time = this.getDateRange[1].getTime() - this.getDateRange[0].getTime();
        // To calculate the no. of days between two dates
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        mean = (counter / (Difference_In_Days + 1)).toFixed(2);
      }
      return mean;
    },
    maxTemperature: function () {
      let maxTemp;
      let temps = this.getTemperaturesList
        ? this.getTemperaturesList.map((item) => item.temperature)
        : //? this.getTemperaturesList.map(item => item.temperature)
          null;

      if (temps && temps.length > 0) {
        maxTemp = Math.max.apply(null, temps).toFixed(1);
      }
      return maxTemp;
    },
    minTemperature: function () {
      let minTemp;
      let temps = this.getTemperaturesList ? this.getTemperaturesList.map((item) => item.temperature) : null;
      if (temps && temps.length > 0) {
        minTemp = Math.min.apply(null, temps).toFixed(1);
      }
      return minTemp;
    },
    /*     getActualTemperatures: function() {
      // Ritorna header e temperature da passare alla funzione che crea il .CSV
      let temperatures = [];
      let headers = {};
      let title;
      let devEui = this.getSelectedSensor.eui;
      headers = {
        //id: "ID",
        eui: "Device",
        date: "Data (Locale)",
        temp: "Temperatura (°C)",
      };
      temperatures = this.getTemperaturesList.map(function(item) {
        return {
          //id: item._id,
          eui: item.eui.substr(item.eui.length - 4),
          date: new Date(item.date).toLocaleString().replace(/,/g, ""),
          temp: item.temperature.toFixed(2),
          //temp: item.temperature
        };
      });
      title = "Report Temperature " + devEui.substr(devEui.length - 4);
      return { title: title, headers: headers, events: temperatures };
    }, */
  },
  methods: {
    ...mapActions({
      setEventsSensors: "eventdetails/setSelectedSensor",
      setDateRange: "eventdetails/setDateRange",
      fetchEventList: "eventdetails/fetchEventList",
      fetchDispDetails: "eventdetails/fetchDispDetails",
      setRelativeMode: "eventdetails/setRelativeMode",
      fetchAccDetails: "eventdetails/fetchAccDetails",
      setLoadingStatus: "eventdetails/setLoadingStatus",
    }),
    filterBySensor: function (values) {
      this.setEventsSensors(values);
    },
    dateSelected: function (dateRange) {
      this.setDateRange(dateRange);
    },
    formatDate: function (date) {
      let day = date.getDate();
      let year = date.getFullYear();
      let month = date.toLocaleString("default", { month: "short" });
      return day + " " + month + " " + year;
    },
    calendarHandler: function () {
      this.showCalendar = !this.showCalendar;
    },
    updateDate: function () {
      this.setDateRange(this.actualDateRange);
      this.showCalendar = false;
    },
    rangeSelected: function (dateRange) {
      this.actualDateRange = dateRange;
    },
    getAcualMainEvents: async function (selectedSensor) {
      // Ritorna header ed eventi da passare alla funzione che crea il .CSV
      let events = [];
      let headers = {};
      let title;
      let offset;
      let devEui = selectedSensor.eui;
      let type = selectedSensor.type;
      let subType = selectedSensor.subType;
      let mesUnit = this.mesUnit;
      let fetchedList;
      switch (type) {
        case "deck":
          if (this.downloadSelSensorOnly) {
            fetchedList = this.getDispList;
          } else {
            await this.setLoadingStatus(false);
            const totalList = await Promise.all(
              this.getSensors.filter((sn) => sn.type === type).map((sn) => api.getDisplacementsList(sn.eui, this.getDateRange[0], this.getDateRange[1]))
            );
            await this.setLoadingStatus(true);
            fetchedList = [].concat(...totalList);
          }
          events = fetchedList
            .sort((a, b) => (this.downloadDescDate ? null : a.date.localeCompare(b.date)))
            .map(function (item) {
              return {
                //id: item._id,
                eui: item.eui.substr(item.eui.length - 4),
                date: new Date(item.date).toLocaleString().replace(/,/g, ""),
                piccoMax: item.payload.piccoMax,
                piccoMin: item.payload.piccoMin,
                PkToPk: item.payload.piccoMax - item.payload.piccoMin,
              };
            });
          headers = {
            //id: "ID".replace(/,/g, ""), // remove commas to avoid errors
            eui: "Device",
            date: this.$t("message.date") + " (Locale)",
            piccoMax: this.$t("message.maxPeak") + " (mm)",
            piccoMin: this.$t("message.minPeak") + " (mm)",
            PkToPk: this.$t("message.peakToPeak") + " (mm)",
          };
          title = "Report Deck " + (this.downloadSelSensorOnly ? devEui.substr(devEui.length - 4) : "");
          break;
        case "tiltmeter":
          if (this.downloadSelSensorOnly) {
            fetchedList = this.getTilts;
          } else {
            await this.setLoadingStatus(false);
            const totalList = await Promise.all(
              this.getSensors
                .filter((sn) => sn.type === type)
                .map((sn) => api.getTiltsList(sn.eui, this.getDateRange[0], this.getDateRange[1], !this.getRelativeMode, sn.beamFormat))
            );
            await this.setLoadingStatus(true);
            fetchedList = [].concat(...totalList);
          }
          events = fetchedList
            .sort((a, b) => (this.downloadDescDate ? null : a.date.localeCompare(b.date)))
            .map(function (item) {
              return {
                //id: item._id
                eui: item.eui.substr(item.eui.length - 4),
                date: new Date(item.date).toLocaleString().replace(/,/g, ""),
                tiltPhi: mesUnit && mesUnit.degrees === "mm/m" ? math.degreesToMM(item.phiAngle).toFixed(6) : item.phiAngle.toFixed(6),
                tiltTheta: mesUnit && mesUnit.degrees === "mm/m" ? math.degreesToMM(item.thetaAngle).toFixed(6) : item.thetaAngle.toFixed(6),
                tilt3D: mesUnit && mesUnit.degrees === "mm/m" ? math.degreesToMM(item.extraAngle).toFixed(6) : item.extraAngle.toFixed(6),
                x: item.x,
                y: item.y,
                z: item.z,
              };
            });
          headers = {
            //id: "ID".replace(/,/g, ""), // remove commas to avoid errors
            eui: "Device",
            date: this.$t("message.date") + " (Locale)",
            tiltPhi: "Tilt Phi " + (mesUnit && mesUnit.degrees === "mm/m" ? "mm/m" : "°"),
            tiltTheta: "Tilt Theta " + (mesUnit && mesUnit.degrees === "mm/m" ? "mm/m" : "°"),
            tilt3D: "Tilt 3D " + (mesUnit && mesUnit.degrees === "mm/m" ? "mm/m" : "°"),
            x: "Asse X",
            y: "Asse Y",
            z: "Asse Z",
          };
          title = "Report Inclinometro " + (this.downloadSelSensorOnly ? devEui.substr(devEui.length - 4) : "");
          break;
        case "accelerometer":
          if (this.downloadSelSensorOnly) {
            fetchedList = this.getAccelerations;
          } else {
            await this.setLoadingStatus(false);
            const totalList = await Promise.all(
              this.getSensors.filter((sn) => sn.type === type).map((sn) => api.getAccelerationsList(sn.eui, this.getDateRange[0], this.getDateRange[1]))
            );
            await this.setLoadingStatus(true);
            fetchedList = [].concat(...totalList);
          }
          events = fetchedList
            .sort((a, b) => (this.downloadDescDate ? null : a.date.localeCompare(b.date)))
            .map(function (item) {
              return {
                //id: item._id,
                eui: item.eui.substr(item.eui.length - 4),
                date: new Date(item.date).toLocaleString().replace(/,/g, ""),
                accX: item.acceleration.xPeak * 1000,
                accY: item.acceleration.yPeak * 1000,
                accZ: item.acceleration.zPeak * 1000,
              };
            });
          headers = {
            //id: "ID".replace(/,/g, ""), // remove commas to avoid errors
            eui: "Device",
            date: this.$t("message.date") + " (Locale)",
            accX: "Pk-Pk X Acc (mg)",
            accY: "Pk-Pk Y Acc (mg)",
            accZ: "Pk-Pk Z Acc (mg)",
          };
          title = "Report Accelerometro " + (this.downloadSelSensorOnly ? devEui.substr(devEui.length - 4) : "");
          break;
        case "analog-node":
          if (this.downloadSelSensorOnly) {
            fetchedList = this.getAnalogReadings;
          } else {
            await this.setLoadingStatus(false);
            const totalList = await Promise.all(
              this.getSensors.filter((sn) => sn.type === type).map((sn) => api.getAnalogReadings(sn.eui, this.getDateRange[0], this.getDateRange[1]))
            );
            await this.setLoadingStatus(true);
            fetchedList = [].concat(...totalList);
          }
          events = fetchedList
            .sort((a, b) => (this.downloadDescDate ? null : a.date.localeCompare(b.date)))
            .map(function (item) {
              return {
                //id: item._id,
                eui: item.eui.substr(item.eui.length - 4),
                date: new Date(item.date).toLocaleString().replace(/,/g, ""),
                CH1: item.channelsData[0],
                CH2: item.channelsData[1],
                CH3: item.channelsData[2],
                CH4: item.channelsData[3],
              };
            });
          headers = {
            //id: "ID".replace(/,/g, ""), // remove commas to avoid errors
            eui: "Device",
            date: this.$t("message.date") + " (Locale)",
            CH1: "Channel 1",
            CH2: "Channel 2",
            CH3: "Channel 3",
            CH4: "Channel 4",
          };
          title = "Report Nodo Analogico " + (this.downloadSelSensorOnly ? devEui.substr(devEui.length - 4) : "");
          break;
        case "crackmeter":
          offset = this.getRelativeMode && this.getBaseValue ? this.getBaseValue : 0;
          if (this.downloadSelSensorOnly) {
            fetchedList = this.getCracks;
          } else {
            await this.setLoadingStatus(false);
            const totalList = await Promise.all(
              this.getSensors.filter((sn) => sn.type === type).map((sn) => api.getCracksList(sn.eui, this.getDateRange[0], this.getDateRange[1]))
            );
            await this.setLoadingStatus(true);
            fetchedList = [].concat(...totalList);
          }
          events = fetchedList
            .sort((a, b) => (this.downloadDescDate ? null : a.date.localeCompare(b.date)))
            .map(function (item) {
              let computedSample = subType === "loadcell" ? (item.sample / (3.92 * Math.pow(10, -3)) - 6400) * 11.71875 : item.sample - offset;
              return {
                //id: item._id,
                eui: item.eui.substr(item.eui.length - 4),
                date: new Date(item.date).toLocaleString().replace(/,/g, ""),
                sample: computedSample,
              };
            });
          headers = {
            //id: "ID".replace(/,/g, ""), // remove commas to avoid errors
            eui: "Device",
            date: "Data (Locale)",
            sample: subType === "loadcell" ? "Load (N)" : "Sample (mm)",
          };
          title = "Report Crackmeter " + (this.downloadSelSensorOnly ? devEui.substr(devEui.length - 4) : "");
          break;
      }
      return this.getIsThereData ? { title: title, headers: headers, events: events } : null;
    },
    downloadEvents: async function () {
      const selectedSensor = this.getSelectedSensor;
      const eventsList = await this.getAcualMainEvents(selectedSensor);
      download.exportCSVFile(
        // Scarica Eventi del device (no temperature)
        eventsList.headers,
        eventsList.events,
        eventsList.title
      );
    },
    /*     downloadTemperatures() {
      download.exportCSVFile(
        this.getActualTemperatures.headers,
        this.getActualTemperatures.events,
        this.getActualTemperatures.title
      );
    }, */
  },
  watch: {
    getSelectedSensor: {
      handler: async function () {
        // Init and Date already ok
        this.loaded = false;
        await this.fetchEventList();
        if (this.getDispList && this.getDispList.length > 0) await this.fetchDispDetails(this.getDispList[0]._id);
        if (this.getAccelerations && this.getAccelerations.length > 0) await this.fetchAccDetails(this.getAccelerations[0]._id);
        this.loaded = true;

        this.firstExec = false;
      },
      deep: true,
    },
    sensors: {
      handler: async function () {
        // Init and Sensor already ok{
        //await this.setEventsSensors(this.deckList[0]);
        await this.fetchEventList();
        if (this.getDispList && this.getDispList.length > 0) await this.fetchDispDetails(this.getDispList[0]._id);
        if (this.getAccelerations && this.getAccelerations.length > 0) await this.fetchAccDetails(this.getAccelerations[0]._id);
      },
    },
    getDateRange: {
      handler: async function (newVal, oldVal) {
        // Init and Sensor already ok
        if ((oldVal[0] && oldVal[1] && (newVal[0].getTime() != oldVal[0].getTime() || newVal[1].getTime() != oldVal[1].getTime())) || this.firstExec) {
          if (!this.firstExec) {
            this.loaded = false;
            await this.fetchEventList();
            if (this.getDispList && this.getDispList.length > 0) await this.fetchDispDetails(this.getDispList[0]._id);
            if (this.getAccelerations && this.getAccelerations.length > 0) await this.fetchAccDetails(this.getAccelerations[0]._id);
            this.loaded = true;
          }
          this.firstExec = false;
        }
      },
      deep: true,
    },
  },
  async mounted() {
    await this.setDateRange([this.isLambro ? new Date('2021-04-20') : new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000), this.isLambro ? new Date('2021-04-23') : new Date()]);
    this.actualDateRange = [this.getDateRange[0], this.getDateRange[1]];
  },
};
</script>
<style scoped>
.download-button > br {
  display: block;
  /* margin: 10px 0; */
}

.download-button > span {
  display: contents;
  font-weight: 500;
}
/* Root Wrapper */
.bridge-info-block {
  min-width: 1020px;
  width: 100vw;
  margin-top: 40px;
  display: grid;
  grid-template-columns: 70% 30%;
  z-index: 2;
  justify-items: center;
  align-content: center;
  grid-template-rows: 60px min-content min-content;
  background-color: rgb(45, 48, 65);
  /*   -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75); */
}

/* @media all and (max-width: 1499px) and (min-width: 300px) {
  .bridge-info-block {
    grid-template-rows: 60px 11px auto;
  }
} */

/* Bridge Wrapper */
.bridge-draw-block {
  grid-row: 3;
  grid-column: 1;
  align-self: center;
  max-width: 100%;
  width: 100%;
  min-height: 508px;
  /* overflow: hidden; */
}

/* Divisori */
.horiz-divider {
  grid-row: 2;
  height: 2px;
  background-color: rgba(80, 84, 105, 1);
  /*   margin-top: 15px;
  margin-bottom: 10px; */
  width: -webkit-fill-available;
  /* min-width: 1080px; */
  margin-left: 120px;
  margin-right: auto;
  grid-column-start: 1;
  grid-column-end: 3;
  box-sizing: border-box;
}

.vert-divider {
  margin-right: 3vw;
  width: 2px;
  height: 40px;
  background-color: rgba(80, 84, 105, 1);
  position: relative;
  justify-self: end;
}

#event-info {
  grid-column-start: 1;
  grid-column-end: 4;
  justify-self: flex-start;
  /* align-self: center; */
  margin-left: 120px;
  display: flex;
  align-items: center;
}

#event-info > h2 {
  margin: 0;
  text-align: left;
  margin-right: 4vw;
  min-width: 300px;
}

@media all and (max-width: 1799px) and (min-width: 300px) {
  #event-info {
    margin-left: 30px;
  }
  .horiz-divider {
    margin-left: 30px;
  }
}

.info-group {
  display: flex;
  align-items: center;
  align-self: center;
  min-width: 450px;
}

.info-group > h2 {
  margin: 0;
  margin-left: 10px;
}
.info-group > p {
  margin: 0;
}

i {
  border: solid white;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 5px;
  position: relative;
  margin-bottom: auto;
  margin-top: auto;
  margin-left: 10px;
  bottom: 2px;
  transition: transform 0.3s cubic-bezier(0.42, 0, 0.1, 0.96);
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
}

#cal-events {
  position: absolute;
  right: 30%;
  top: 203px;
  max-width: 770px;
  width: 770px;
  background-color: rgb(45, 48, 65);
  z-index: 12;
}

.ciao {
  border-radius: 10px;
  border-style: solid;
  border-width: 2px;
  border-color: rgb(91, 96, 118);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

#relative-switch {
  display: flex;
  align-items: center;
  /*   justify-self: end;
 */
  width: max-content;
  margin-left: 6vw;
}

#relative-switch > p {
  margin: 0;
  font-weight: 500;
  min-width: 120px;
}

@media all and (max-width: 1499px) and (min-width: 300px) {
  #relative-switch {
    margin-left: 1vw;
  }
}

.relative-switch {
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.relative-switch > p {
  margin-right: 10px;
}

.overview {
  grid-column: 2;
  text-align: left;
  align-content: flex-start;
  width: 100%;
  padding: 0 40px 0 40px;
  box-sizing: border-box;
  padding-top: 40px;
  min-width: 400px;
  z-index: 99;
  background-color: rgb(45, 48, 65);
}

.buttons-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 30px;
  color: white;
  background-color: rgb(30, 31, 43);
  padding: 20px;
  border-radius: 10px;
  font-size: 0.9em;
}
select {
  padding: 0;
  padding-right: 20px;
  margin: 5px 0;
  margin-left: 5px;
  font-size: 1.1em;
  font-weight: 700;
}
.data-info {
  height: 40px;
  background-color: rgb(30, 31, 43);
  border-radius: 5px;
  width: 100%;
  margin-top: 15px;
  display: flex;
}

.data-label {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 15px;
  width: 85%;
}
.data-value {
  color: white;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 15px;
}

.download-icon {
  width: 100%;
  margin-top: 42px;
  display: flex;
  transition: transform 0.1s linear;
}

.download-button {
  width: 100%;
  margin-top: 20px;
  background-color: rgb(80, 84, 105);
  display: flex;
  border-radius: 10px;
  border: solid 3px white;
  height: 52px;
  justify-content: center;
  align-items: center;
  text-align: left;
  line-height: 17px;
  text-decoration: none;
  outline: none;
  color: #fff;
  font-family: inherit;
  font-size: 0.8em;
  font-weight: 700;
  transition: transform 0.1s linear;
}

.download-button:hover {
  background-color: rgb(9, 109, 177);
  -webkit-transition: background-color 100ms linear;
  -ms-transition: background-color 100ms linear;
  transition: background-color 100ms linear;
}

.download-button:active {
  background-color: rgb(21, 146, 230);
  transform: translateY(3px);
}

.download-button:disabled:hover {
  background-color: rgb(80, 84, 105);
}

.download-button:disabled:active {
  background-color: rgb(80, 84, 105);
  transform: translateY(0px);
}

.down-small {
  margin-right: 12px;
}

@media all and (max-width: 1499px) and (min-width: 300px) {
  /*   .overview {
    margin-top: 25px;
  } */
  .bridge-info-block {
    grid-template-columns: 70% 30%;
  }
}
</style>
